import { Price } from "@modules/boxOffer/entities/boxOfferTypes"
import { LightBoxOfferInfoDto } from "@modules/boxOffer/gateway/boxOfferDto"
import { CouponType } from "@modules/common/couponObject/gateway/couponObjectApiDto"
import { PromoCodeArchivedStatus } from "@modules/promoCode/services/promoCodeDto"
import { BoxPromoCode } from "@modules/promoCode/types/boxPromoCodeTypes"

export type BoxPromoCodeDto = {
  id: string
  title: string
  code: string
  type: CouponType
  value: number
  createdAt: string
  expirationDate?: string
  durationInMonths?: number
  maxAttendees?: number
  onlyNewCustomer: boolean
  archived: boolean
  archivedStatus?: PromoCodeArchivedStatus
  boxOffers?: LightBoxOfferInfoDto[]
}

export const convertBoxPromoCodeFromDto = (dto: BoxPromoCodeDto): BoxPromoCode => {
  return {
    ...dto,
    boxOffers:
      dto.boxOffers?.map((boxOffer) => ({
        ...boxOffer,
        price: boxOffer.price as Price,
      })) ?? [],
  }
}
